import React, { useEffect, useState, useContext } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import Sidebar from "../components/Sidebar";
import { Player, BigPlayButton } from "video-react";
import "video-react/dist/video-react.css"; // Import Video.js styles
import YouTube from "react-youtube";
import Curriculum from "./Curriculum";
import SliderWeek1 from "./SliderWeek1";
import { useLocation } from "react-router-dom";
import axios from "axios";
import NavbarBack from "../components/NavbarBack";
import { toast, Toaster } from 'react-hot-toast';
import SliderWeek6 from "./SliderWeek6";
import SliderWeek6_2 from "./SliderWeek6_2";
import SliderWeek6_3 from "./SliderWeek6_3";
import SliderWeek6_4 from "./SliderWeek6_4";
import Quote from "../components/Quote";
import Collapse from "../components/Collapse";
import Vimeo from '@u-wave/react-vimeo';
import SliderWeek8 from "./SliderWeek8";
import CardFlip from "./CardFlip";
import SliderWeek9 from "./SliderWeek9";
import SliderWeek10 from "./SliderWeek10";
import SliderWeek10_2 from "./SliderWeek10_2";
import QuizComponent from "./QuizComponent";
import SliderWeek11 from "./SliderWeek11";
import SliderWeek11_2 from "./SliderWeek11_2";
import { axiosInstance } from "../Axios";
import Confetti from 'react-confetti';

const Week11 = () => {
  let { user } = useContext(AuthContext);
  const week_id = 12;
  const week_name = "week_11";
  const pathway_id = 1;
  // extract profile id
  const location = useLocation();
  const { server_progress } = location.state;
  let status = server_progress.status;
  let section = server_progress.section;
  let params = useParams();
  let profileID = user["user_id"];
  const [currentStep, setCurrentStep] = useState(server_progress.section || 0);


  // validate the user if he is the owner of the profile
  let isMyself = true;

  if (user !== null && user["user_id"] === parseInt(profileID)) {
    isMyself = true;
  }

  // initalize thread and posts component state
  const [profile, setProfile] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const [loading, setLoading] = useState(true);
  const [swotSubmission, setSubmission] = useState({
    response: "",
  });
  const [assignedReview, setAssigned] = useState({
    stakeholders: "",
    choices: "",
    principles: "",
  });
  const [swotFeedback, setFeedback] = useState("");

  const fetchAssignedReview = async (user_id, week_id, week_name, section) => {
    axiosInstance
      .post(`${process.env.REACT_APP_API_KEY}/api/get_assigned_submission/`, {
        user_id: user_id,
        week_id: week_id,
        week_name: week_name,
        section: section,
        pathway: pathway_id,
      })
      .then((response) => {
        console.log(response);
        toast.success('Good Job! Activity Submitted', {
          icon: '👏',
          style: {
            borderRadius: '55px',
            marginBottom: '15px',
          },
        });
        if (response.status === 200) {
          let data = JSON.parse(response.data.content);
          setAssigned({
            // strengths: data.strengths,
            // weaknesses: data.weaknesses,
            // opportunities: data.opportunities,
            // threats: data.threats,
            stakeholders: data.stakeholders,
            choices: data.choices,
            principles: data.principles,
          });
          setFeedback(response.data.feedback);
        }
      });
  };
  const fetchStepData = async (
    user_id,
    week_id,
    week_name,
    section,
    pathway
  ) => {
    axiosInstance
      .post(`${process.env.REACT_APP_API_KEY}/api/get_peer_submission/`, {
        user_id: user_id,
        week_id: week_id,
        week_name: week_name,
        section: section,
        pathway: pathway,
      })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          let data = JSON.parse(response.data.content);
          toast.success('Good Job! Activity Submitted', {
            icon: '👏',
            style: {
              borderRadius: '55px',
              marginBottom: '15px',
            },
          });
          setSubmission({
            stakeholders: data.stakeholders,
            choices: data.choices,
            principles: data.principles,
            
          });
        }
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = axiosInstance.get(
          `${process.env.REACT_APP_API_KEY}/api/profile/${profileID}`
        );
        let data = await response.json();
        setProfile(data);
        setLoading(false);
      } catch (err) {
        console.log("The requested profile does not exist.");
        setLoading(false); // Set loading to false even on error to stop showing the loader
      }
    };

    // Simulate the loader by setting a timer for 3 seconds
    const timer = setTimeout(() => {
      fetchData();
      fetchStepData(profileID, week_id, week_name, 4, pathway_id);
      fetchAssignedReview(profileID, week_id, week_name, 4);
    }, 900);

    // Clean up the timer when the component unmounts
    return () => clearTimeout(timer);
  }, [profileID]);
  //console.log(profile);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScroll(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const videoId = "eqCNw8WXtQ8"; // Extract the video ID from the YouTube URL

  const opts = {
    width: "100%",
    height: "15vh", // Set the height to 100%
    playerVars: {
      autoplay: 0,
    },
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleImageIndexChange = (index) => {
    setCurrentImageIndex(index);
  };

  const handleNext = () => {
    if (currentStep <= totalSteps - 1) {
      if (status === "Active") {
        let new_step = currentStep + 1;
        if (new_step > section) {
          let status = "Active";
          if (new_step === totalSteps) {
            status = "Completed";
          }
          axiosInstance
            .put(
              `${process.env.REACT_APP_API_KEY}/api/update_pathway_progress/`,
              {
                user_id: user.user_id,
                section: new_step,
                week_name: week_name,
                week_id: week_id,
                status: status,
                pathway_id,
                next_week_name: "week_12",
              }
            )
            .then((res) => {
              console.log(res);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }

      setCurrentStep(currentStep + 1);
    }
    console.log(currentStep);
  };
  const navigate = useNavigate();

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  console.log(swotSubmission);
  const handleStepSubmission = () => {
    console.log("this steo", currentStep);
    if (status === "Active" || status == "Completed") {
      if (currentStep === 5) {
        axiosInstance.post(`${process.env.REACT_APP_API_KEY}/api/peer_feedback/`, {
          user_id: user.user_id,
          week_name: week_name,
          week_id: week_id,
          section: 4,
          content: swotSubmission,
          pathway: 1,
          feedback: swotFeedback,
          rating: 0
        });
        toast.success('Good Job! Feedback Submitted', {
          icon: '👏',
          style: {
            borderRadius: '55px',
            marginBottom: '15px',
          },
        });
        return;
      } else {
        axiosInstance.post(`${process.env.REACT_APP_API_KEY}/api/peer_submission/`, {
          user_id: user.user_id,
          week_name: week_name,
          week_id: week_id,
          section: currentStep,
          content: swotSubmission,
          pathway: 1,
          status: "Reviewing",
          rating: 0,
          pr_enabled: true,
          activity_name: "Adaptation in Action-Navigating Change",
        });
        toast.success('Good Job! Activity Submitted', {
          icon: '👏',
          style: {
            borderRadius: '55px',
            marginBottom: '15px',
          },
        });
      }
    }
  };

  const totalSteps = 9; // Total number of steps

  const bullet = "\u2022";
  const bulletWithSpace = `${bullet} `;
  const enter = 13;

  const handleInput = (event) => {
    const { keyCode, target } = event;
    const { selectionStart, value } = target;

    if (keyCode === enter) {
      console.log("a");
      target.value = [...value]
        .map((c, i) => (i === selectionStart - 1 ? `\n${bulletWithSpace}` : c))
        .join("");
      console.log(target.value);

      target.selectionStart = selectionStart + bulletWithSpace.length;
      target.selectionEnd = selectionStart + bulletWithSpace.length;
    }

    if (value[0] !== bullet) {
      target.value = `${bulletWithSpace}${value}`;
    }
    checkTextareas();
  };

  const [disableNext, setDisableNext] = useState(true);
  const checkTextareas = () => {
    const textareas = document.querySelectorAll(".textarea");
    let disable = false;

    textareas.forEach((textarea) => {
      if (textarea.value.trim() === "" || textarea.value.trim() === "\u2022") {
        disable = true;
      }
    });

    setDisableNext(disable);
  };


  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [showExplanation, setShowExplanation] = useState(false);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleNextQuestion = () => {
    setShowExplanation(true);
  };

  const handleNextQuestionOrFinish = () => {
    if (currentQuestion + 1 < questionsData.length) {
      setCurrentQuestion(currentQuestion + 1);
      setSelectedOption("");
      setShowExplanation(false);
    }
  };





  const [currentQuestion2, setCurrentQuestion2] = useState(0);
  const [selectedOption2, setSelectedOption2] = useState("");
  const [showExplanation2, setShowExplanation2] = useState(false);

  const handleOptionSelect2 = (option2) => {
    setSelectedOption2(option2);
  };

  const handleNextQuestion2 = () => {
    setShowExplanation2(true);
  };

  const handleNextQuestionOrFinish2 = () => {
    if (currentQuestion2 + 1 < questionsData2.length) {
      setCurrentQuestion2(currentQuestion2 + 1);
      setSelectedOption2("");
      setShowExplanation2(false);
    }
  };



  const questionsData = [
    {
      question: "Always aiming for perfection in the first attempt at idea generation is crucial for creativity.",
      options: ["Truth", "Myth"],
      correctAnswer: "Myth",
    },
    {
      question: "Combining unrelated ideas or concepts can lead to innovative solutions.",
      options: ["Truth ", "Myth"],
      correctAnswer: "Truth",
    },
    {
      question: "Creativity is only about generating completely new ideas, never about modifying existing ones.",
      options: ["Truth", "Myth "],
      correctAnswer: "Myth",
    },
    {
      question: "Constraints and limitations hinder the creative process and should always be avoided.",
      options: ["Truth", "Myth "],
      correctAnswer: "Myth",
    },
    {
      question: "Using structured techniques for creative thinking stifles spontaneity and genuine innovation.",
      options: ["Truth", "Myth "],
      correctAnswer: "Myth",
    },
  ];
  
  
  const questionsData2 = [
    {
      question: "Groups are less effective in adapting to change compared to individuals.",
      options: ["Truth", "Myth"],
      correctAnswer: "Myth",
    },
    {
      question: "Constant communication is not necessary for groups to adapt effectively to uncertainty.",
      options: ["Truth", "Myth"],
      correctAnswer: "Myth",
    },
    {
      question: "In uncertain situations, the most adaptive groups are those that resist change and stick to their original plan.",
      options: ["Truth", "Myth"],
      correctAnswer: "Myth",
    },
    {
      question: "Embracing diverse viewpoints helps groups better navigate ambiguous situations.",
      options: ["Truth", "Myth"],
      correctAnswer: "Truth",
    },
    {
      question: "Rigid adherence to established procedures is the best approach in times of uncertainty.",
      options: ["Truth", "Myth"],
      correctAnswer: "Myth",
    },
  ];
  
  


  const accordionData = [
    {
      title: 'Expanding Your Change-Embracing Lens',
      content: (
        <div>
          <p>(Are you open and responsive to change in all its forms?)</p>
          <strong>Mindsets to Cultivate:</strong>
          <ul className="px-8" style={{ listStyle: 'disc' }}>
            <li>Openness to New Ideas: Avoid dismissing change without consideration.</li>
            <li>Valuing Diverse Perspectives: Actively seek and include different viewpoints when facing change.</li>
            <li>Creativity in Adapting: Encourage innovative thinking in adapting to change.</li>
            <li>Long-term Vision: Balance immediate reactions to change with the importance of long-term adaptability.</li>
          </ul>
        </div>
      ),
    },
    {
      title: 'Practical Approaches to Embracing Change',
      content: (
        <div>
          <p>(Are your reactions and adaptations to change effective and positive?)</p>
          <strong>Mindsets to Challenge:</strong>
          <ul className="px-8" style={{ listStyle: 'disc' }}>
            <li>Resistance to Change: Assess and overcome hesitancy in embracing new situations.</li>
            <li>Shying Away from Challenges: Face changes head-on, recognizing them as opportunities for growth.</li>
            <li>Sticking to Comfort Zones: Push boundaries and explore new ways of thinking and doing.</li>
            <li>Seeing Change in Isolation: Acknowledge the interconnectedness of change with broader goals and objectives.</li>
          </ul>
        </div>
      ),
    },
    {
      title: 'Reflective Practices for Adapting to Change',
      content: (
        <div>
          <p>(Are you learning and growing from each experience with change?)</p>
          <strong>Mindsets to Cultivate:</strong>
          <ul className="px-8" style={{ listStyle: 'disc' }}>
            <li>Learning from Change: Use each encounter with change as a learning opportunity.</li>
            <li>Positive Reframing of Change: Focus on the beneficial aspects and potential of change.</li>
            <li>Welcoming Constructive Feedback: Embrace feedback on adaptability to change.</li>
            <li>Open Dialogues on Change: Encourage discussions about the impact and process of adapting to change.</li>
          </ul>
          <p><strong>Cultivating an Adaptive Mindset:</strong></p>
          <ul className="px-8" style={{ listStyle: 'disc' }}>
            <li>Regular Self-Assessment: Routinely evaluate your response and approach to change.</li>
            <li>Seeking Diverse Opinions: Actively seek out and consider different perspectives on change.</li>
            <li>Future-Oriented Adaptability: Consider the long-term benefits and potential of adapting to change.</li>
            <li>Transparent Adaptation Process: Maintain clear communication about changes to build trust and support adaptation.</li>
          </ul>
        </div>
      ),
    },
  ];
  


  const accordionData2 = [
    {
      title: 'Focus on the Principles',
      content: 'Consider the broader impact of your actions by framing your decisions around ethical principles rather than short-term gains. Research indicates that leaders who prioritize ethical standards over immediate results cultivate a more loyal, trusting, and high-performing team.'
    },
    {
      title: 'Distinguishing Ethics from Morals',
      content: 'Ground your leadership approach in a clear understanding of both ethics and morals. While morals often stem from individual beliefs and cultural backgrounds, ethics typically refer to the accepted standards of behavior in professional and public domains. Appreciating this distinction can enhance your ability to navigate complex situations with clarity and confidence, creating an environment where ethical considerations guide the way to sustainable success.'
    },
  ];
  

  const accordionData3 = [
    {
      title: 'Vision for the Future',
      content: 'A sustainable leader foresees beyond immediate goals. They set a clear, inspiring long-term vision that guides actions and policies, anticipating future challenges and opportunities. By doing so, they ensure that the organization can adapt and thrive in an ever-changing world.'
    },
    {
      title: 'Ethical Foundations',
      content: 'Ethical leadership is the cornerstone of trust and integrity. Sustainable leaders uphold high ethical standards, make transparent decisions, and act consistently with their values. They inspire others by leading by example and holding themselves accountable, thus fostering a culture of trust.'
    },
    {
      title: 'Environmental Stewardship',
      content: 'Leaders with a sustainable mindset prioritize the environment, recognizing that resources are finite. They innovate to reduce waste, conserve energy, and lower carbon footprints, setting new industry standards. Environmental stewardship becomes a part of the organization\'s identity and mission.'
    },
    {
      title: 'Community Enrichment',
      content: 'Sustainable leadership involves a commitment to the well-being of the community. Leaders invest in social initiatives, support educational programs, and engage in partnerships that address social issues. Their legacy is marked by the positive impact on the community’s health, wealth, and social fabric.'
    },
  ];


  const accordionData82 = [
    {
      title: 'Cultivate a Shared Vision',
      content: '- Establishing a shared vision is fundamental for aligning team efforts towards common goals.\n' +
        'Reflect on your recent team interactions:\n' +
        '- How have I communicated and fostered a shared vision within the team?\n' +
        '- In what ways have I ensured that everyone understands and is committed to our collective goals?\n' +
        '- What strategies can I employ to reinforce our vision and keep the team motivated and focused on long-term objectives?',
    },
    {
      title: 'Analyse and Set SMART Goals',
      content: '- Effective goal setting is a collaborative and strategic process. Evaluate your team\'s approach to setting goals:\n' +
        '- How do we define and agree upon our goals? Are they Specific, Measurable, Achievable, Relevant, and Time-bound (SMART)?\n' +
        '- Where can we improve in making our goals more aligned with our strategic vision?\n' +
        '- How can I lead the team to break down our larger vision into achievable, strategically informed goals?',
    },
    {
      title: 'Encourage Participation in Vision and Goal Setting',
      content: '- Active participation in vision and goal setting is key to team buy-in and commitment. Assess your role in facilitating this involvement:\n' +
        '- Have I created opportunities for every team member to contribute to our vision and goal-setting process?\n' +
        '- How can I better ensure that all voices are heard and considered in shaping our team\'s direction?\n' +
        '- In what ways can I empower each member to take ownership of parts of our vision and goals, thereby strengthening their commitment and the team\'s cohesion?',
    },
  ];
  

  const accordionData4 = [
    {
      title: 'Developing a Structured Research Approach',
      content: '- Structuring your research is vital for effective information gathering.\n' +
        '- Reflect on your recent research tasks:\n' +
        '  - How do I define my research objectives?\n' +
        '  - What strategies am I using to collect and organize information?\n' +
        '  - How do I ensure the sources I use are credible and relevant?',
    },
    {
      title: 'Analysing Information and Drawing Insights',
      content: '- The essence of research lies in analyzing information and extracting valuable insights.\n' +
        '- Assess your recent research endeavors:\n' +
        '  - How do I analyze the data and information I gather?\n' +
        '  - In what ways do I synthesize information to draw meaningful conclusions?\n' +
        '  - How do I ensure my analysis is unbiased and objective?',
    },
    {
      title: 'Incorporating Diverse Perspectives and Feedback',
      content: '- Including diverse perspectives enhances the depth and breadth of your research.\n' +
        '- Evaluate your approach to incorporating different viewpoints:\n' +
        '  - Have I considered alternative perspectives in my research?\n' +
        '  - How do I seek and incorporate feedback to refine my research?\n' +
        '  - What steps do I take to challenge my assumptions and broaden my understanding?',
    },
  ];
  
  const accordionData5 = [
    {
      title: 'Fundamentals of Financial Statements and Budgets',
      content: '- Mastering the basics of financial statements and budgets is fundamental.\n' +
        '- Self-Reflection Points:\n' +
        '  - How do I interpret key financial documents like balance sheets and income statements?\n' +
        '  - In what ways do I apply this understanding to manage budgets for society events or personal finance projects?\n' +
        '  - What resources or tools could enhance my skills in financial statement analysis?',
    },
    {
      title: 'Evaluating Financial Health and Performance',
      content: '- Assessing financial health is crucial for the sustainability of any initiative.\n' +
        '- Self-Reflection Points:\n' +
        '  - How do I determine the financial viability of a project or society event?\n' +
        '  - What metrics or indicators are useful in assessing financial performance?\n' +
        '  - How can financial data guide more sustainable decision-making processes?',
    },
    {
      title: 'Risk Assessment in Financial Decision-Making',
      content: '- Understanding and managing financial risks is key to sound financial decision-making.\n' +
        '- Self-Reflection Points:\n' +
        '  - How do I identify potential financial risks in my projects or society activities?\n' +
        '  - What strategies do I employ to mitigate these risks?\n' +
        '  - How do I balance potential risks and rewards when making financial decisions?',
    },
  ];
  
  const accordionData6 = [
    {
      title: 'Explore the Pillars of Sustainable Leadership',
      content:
      'A sustainable leader foresees beyond immediate goals. They set a clear, inspiring long-term vision that guides actions and policies, anticipating future challenges and opportunities. By doing so, they ensure that the organization can adapt and thrive in an ever-changing world.\n\n' +
      'Ethical leadership is the cornerstone of trust and integrity. Sustainable leaders uphold high ethical standards, make transparent decisions, and act consistently with their values. They inspire others by leading by example and holding themselves accountable, thus fostering a culture of trust.\n\n' +
      'Leaders with a sustainable mindset prioritize the environment, recognizing that resources are finite. They innovate to reduce waste, conserve energy, and lower carbon footprints, setting new industry standards. Environmental stewardship becomes a part of the organization\'s identity and mission.\n\n',
    }
    
  ];


  const accordionData7 = [
    {
      title: 'Additional Resources for Further Learning ',
      content: (
        <div>
          <p>
            Ted Talk: "Grit: The Power of Passion and Perseverance" by Angela Lee Duckworth
          </p>
          <p>
            Ted Talk: "3 Ways to Plan for the (Very) Long Term" by Ari Wallach
          </p>
          <p>
            "Who Moved My Cheese?" by Spencer Johnson, Chapter 3 - The Cheese and the Maze
          </p>
          <p>
            "Change Management: The People Side of Change" by Jeffrey M. Hiatt, Chapter 3 – Adapting to Change
          </p>
          <p>
            "The Art of the Long View" by Peter Schwartz, Chapter 6 – The Global Teenager's Dilemmas
          </p>
          <p>
            "Who Moved My Cheese?" by Spencer Johnson, Chapter 8 – Embracing Change
          </p>
        </div>
      ),
    },
  ];
  
  
  
  const cardData = [
    {
      id: 1,
      frontContent: 'Embracing Flexibility in Problem-Solving',
      backContent: (
        <div>
          <p>
            Reflect on your approach to problem-solving:
          </p>
          <ul className="px-8" style={{ listStyle: 'decimal' }}>
            <li>How do I adjust my problem-solving strategies in response to unexpected situations or new information?</li>
            <li>In what ways have I shown flexibility in finding solutions to challenges in academic or professional settings?</li>
            <li>What techniques can I develop to become more agile and adaptable in my problem-solving approach?</li>
          </ul>
        </div>
      ),
    },
    {
      id: 2,
      frontContent: 'Adapting Decision-Making Processes ',
      backContent: (
        <div>
          <p>
            Consider your decision-making style:
          </p>
          <ul className="px-8" style={{ listStyle: 'decimal' }}>
            <li>How do I modify my decision-making approach when faced with new or evolving information?</li>
            <li>What methods do I employ to ensure that my decisions are responsive to the current context?</li>
            <li>How can I improve my capacity to make decisions swiftly and effectively in dynamic situations?</li>
          </ul>
        </div>
      ),
    },
    {
      id: 3,
      frontContent: 'Overcoming Rigidity in Thinking ',
      backContent: (
        <div>
          <p>
            Reflect on your cognitive flexibility:
          </p>
          <ul className="px-8" style={{ listStyle: 'decimal' }}>
            <li>How do my established ways of thinking affect my problem-solving and decision-making?</li>
            <li>In what ways might cognitive biases or fixed mindsets limit my adaptability?</li>
            <li>What strategies can I use to foster a more open and flexible approach to decision-making?</li>
          </ul>
        </div>
      ),
    },
    {
      id: 4,
      frontContent: 'The Role of Flexibility ',
      backContent: (
        <div>
          <p>
            Explore the benefits of flexibility:
          </p>
          <ul className="px-8" style={{ listStyle: 'decimal' }}>
            <li>How has being flexible in my approach led to innovative solutions or effective problem-solving in various contexts?</li>
            <li>Can I recall any examples or case studies where flexibility in decision-making resulted in positive outcomes?</li>
            <li>How can I incorporate flexibility into my problem-solving and decision-making to encourage creativity and effective solutions?</li>
          </ul>
        </div>
      ),
    },
    // Add more card data as needed
  ];
  

  const cardData2 = [
    {
      id: 1,
      frontContent: 'Setting Specific Adaptability Goals',
      backContent: (
        <div>
          <strong></strong>
          <p>Content: Defining clear, achievable goals is the first step in your action plan.</p>
          <strong>Self-Reflection Points:</strong>
          <ul className="px-8" style={{ listStyle: 'disc' }}>
            <li>What specific aspects of adaptability do I want to develop or enhance?</li>
            <li>How can these adaptability goals contribute to my effectiveness as a student leader or society member?</li>
            <li>What are the measurable outcomes I aim to achieve through these goals?</li>
          </ul>
        </div>
      ),
    },
    {
      id: 2,
      frontContent: 'Identifying Strategies and Resources',
      backContent: (
        <div>
          <strong></strong>
          <p>Content: Determining the right strategies and resources is key to achieving your goals.</p>
          <strong>Self-Reflection Points:</strong>
          <ul className="px-8" style={{ listStyle: 'disc' }}>
            <li>What strategies will I employ to improve my adaptability in various situations?</li>
            <li>Which resources (like workshops, books, mentors) can assist in developing these skills?</li>
            <li>How will I integrate these strategies and resources into my regular activities or society responsibilities?</li>
          </ul>
        </div>
      ),
    },
    {
      id: 3,
      frontContent: 'Creating a Timeline and Milestones',
      backContent: (
        <div>
          <strong></strong>
          <p>Content: A structured timeline with milestones helps track progress and maintain focus.</p>
          <strong>Self-Reflection Points:</strong>
          <ul className="px-8" style={{ listStyle: 'disc' }}>
            <li>What is a realistic timeline for achieving my adaptability goals?</li>
            <li>What milestones can I set to monitor my progress over time?</li>
            <li>How will I adjust my plan if I encounter obstacles or new opportunities for growth?</li>
          </ul>
        </div>
      ),
    },
    {
      id: 4,
      frontContent: 'Reviewing and Adjusting the Plan',
      backContent: (
        <div>
          <strong></strong>
          <p>Content: Regular review and adjustment of your action plan ensure its effectiveness and relevance.</p>
          <strong>Self-Reflection Points:</strong>
          <ul className="px-8" style={{ listStyle: 'disc' }}>
            <li>How will I periodically review the progress of my action plan?</li>
            <li>What criteria will I use to evaluate its success or areas needing adjustment?</li>
            <li>How open am I to modifying my plan based on feedback and new experiences?</li>
          </ul>
        </div>
      ),
    },
    // Add more card data as needed
  ];
  
  

  const steps = [
    // Define the content and structure of each step
    <section className="bg-white contMain gpWindow rounded-lg mt-6 p-8 my-24">
      {/* Step 1 content */}
      <h2 className="text-xl font-medium sm:text-xl">
        Welcome to <b>Week 11: Adaptability- The Keystone of Modern Leadership</b>
      </h2>
      <p className="mt-4 text-gray-600">
      Welcome to Week 11 of the "Ascent" leadership pathway: Adaptability - The Keystone of Modern Leadership. In a world that is continuously evolving, adaptability stands out as a crucial skill for leaders. It's not merely about adjusting to change; it's about thriving in the midst of it. This week, we will explore the multifaceted nature of adaptability, understanding its significance in navigating complex, unpredictable environments. We will delve into self-assessment and awareness, fostering a growth mindset, and the importance of learning agility. Our journey will also take us through the nuances of cultural adaptability and practical applications in real-world scenarios. As we progress, we will craft personalised action plans to enhance our adaptive capabilities. Join us as we master the art of adaptability, transforming challenges into opportunities for growth and innovation.      </p>
      <div className="mt-6 flex justify-center w-full h-full">
      <Quote content={"It is not the strongest of the species that survive, nor the most intelligent, but the one most responsive to change."} person={"Charles Darwin"}/>

      {/* <div
          style={{ width: "100%", borderRadius: "10px", overflow: "hidden" }}
        >
          <div className="video-container">
            <Vimeo
      video={'898992480'}
      autoplay
    />

          </div>
        </div> */}
      </div>
    </section>,
    <section
    className="bg-white contMain  gpWindow rounded-lg mt-6 p-8 my-24"
    style={{ height: "100%" }}
    >
    <div className="mt-6 flex justify-start w-full">
      <SliderWeek11 className='w-full' onImageIndexChange={handleImageIndexChange} />
    
    </div>
    </section>,

<section
className="bg-white contMain  gpWindow rounded-lg mt-6 p-8 my-24"
style={{ height: "100%" }}
>
{/* Step 1 content */}
<h2 className="text-xl font-medium sm:text-xl">
  <b></b>
</h2>
<p className="mt-4 text-gray-600">
</p>



<QuizComponent questionsData={questionsData} />


</section>,

<section
className="bg-white contMain  gpWindow rounded-lg mt-6 p-8 my-24"
style={{ height: "100%" }}
>

<h2 className="text-xl font-medium sm:text-xl">
          <b> Flexibility in Problem-Solving and Decision-Making: Adapting to Dynamic Situations 
 </b>
        </h2>
        <p className="mt-4 text-gray-600">

        Having explored adaptability, it's crucial to focus on flexibility in problem-solving and decision-making. This section examines how being flexible can enhance our ability to make decisions and solve problems effectively in constantly changing environments.


        </p>
<div className="grid grid-cols-1 ">
{cardData.map((card) => (
    
        <CardFlip
          key={card.id}
          frontContent={card.frontContent}
          backContent={card.backContent}
        />
        
      ))}



</div>
</section>,








<section className="bg-white contMain flex items-start flex-row gpWindow rounded-lg mt-6 p-8">
      

<div className="mx-auto max-w-screen-xl px-4 py-8 sm:py-12 sm:px-6 lg:py-16 lg:px-8">
  <div className="grid grid-cols-1 gap-8 lg:grid-cols-1 lg:gap-16">


    <div className="">
      <h2 className="text-xl font-medium sm:text-xl">
        <b>Enhancing Adaptability through Mindset and Attitude Change</b>
      </h2>
      <p className="mt-4 text-gray-600">

      In any role, particularly within dynamic environments like university student-run societies, the ability to embrace and drive change with a positive mindset is essential. This involves challenging the status quo, being open to new ideas, and viewing change as an opportunity for growth and development. Are you recognizing the potential for personal and organisational growth in change? Are your attitudes towards change inclusive and forward-thinking? Integrating a positive attitude towards change in your mindset leads to more agile and effective leadership.      </p>

      <div className="mt-6">
        <div className="container flex flex-col justify-center mx-auto px-0 ">
          <div className="space-y-4">
              <Collapse accordionData={accordionData}/>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>
</section>,


<section
className="bg-white contMain  gpWindow rounded-lg mt-6 p-8 my-24"
style={{ height: "100%" }}
>
<div className="mt-6 flex justify-start w-full">
  <SliderWeek11_2 className='w-full' onImageIndexChange={handleImageIndexChange} />

</div>
</section>,



<section
className="bg-white contMain  gpWindow rounded-lg mt-6 p-8 my-24"
style={{ height: "100%" }}
>
{/* Step 1 content */}
<h2 className="text-xl font-medium sm:text-xl">
<b></b>
</h2>
<p className="mt-4 text-gray-600">
</p>


<QuizComponent questionsData={questionsData2} />


</section>,


<section
className="bg-white contMain  gpWindow rounded-lg mt-6 p-8 my-24"
style={{ height: "100%" }}
>

<h2 className="text-xl font-medium sm:text-xl">
          <b> Explore how to integrate creativity into team dynamics.
 </b>
        </h2>
        <p className="mt-4 text-gray-600">

        In student-run societies and leadership roles, harnessing the collective creative potential of your team is essential. It's about creating an environment where diverse ideas flourish and innovation is the norm. Are you leveraging the unique perspectives of your team members? Do your team dynamics foster collaborative creativity? Incorporating creativity into team settings not only leads to more innovative outcomes but also builds a culture of shared ownership and dynamic thinking.


        </p>
<div className="grid grid-cols-1 ">
{cardData2.map((card) => (
    
        <CardFlip
          key={card.id}
          frontContent={card.frontContent}
          backContent={card.backContent}
        />
        
      ))}

</div>
</section>,



















    <section
      className="bg-white contMain  gpWindow rounded-lg mt-6 p-8 my-24"
      style={{ height: "100%" }}
    >
      {/* Step 1 content */}
      <h2 className="text-xl font-medium sm:text-xl">
        <b>Adaptation in Action-Navigating Change
</b>
      </h2>
      <p className="mt-4 text-gray-600">
      Envision yourself in scenarios that challenge your adaptability skills. These situations could range from handling unexpected changes in your academic path at LUMS, adapting to dynamic conditions in a student-run society, or navigating personal life transitions.      </p>
<br/><br/>
      <strong>Leadership Transition Challenge:</strong> Your student society's President suddenly steps down, and the new President has a vastly different approach. How will you adapt to this change and ensure the society's objectives are still met?
      <br/><strong>Academic Adaptation Challenge:</strong> A course you're taking shifts its focus mid-semester, introducing new content and methods you're unfamiliar with. How will you adjust your learning strategies to cope with this change?
      <br/><strong>Team Dynamics Challenge:</strong> Your project team's composition changes, bringing in members with different working styles. How will you adapt to effectively collaborate and maintain team harmony?


      <p className="mt-4 text-gray-600">
<p>Now, step into the role of an adaptable leader. Reflect on these scenarios and craft a response discussing:</p><br/>
<br/>
<div class="">

    <div class="mb-4">
      <ul class="list-disc pl-6">
        <li>Adaptability Analysis: For each scenario, provide a detailed reflection on how you would adapt to the changes. Explore the impact of these changes on you and the strategies you would use to navigate them. </li>
      </ul>
    </div>

    <div class="mb-4">
      <ul class="list-disc pl-6">
        <li>Learning and Growth: Reflect on how navigating these changes contributes to your personal and professional growth. Identify any new skills or insights you would gain.</li>
      </ul>
    </div>



  </div>

      </p>

      <ul
        className="mt-4 bg-amber-50 p-2 rounded-xl border-2 border-amber-100 text-sm"
        style={{ listStyle: "circle" }}
      >
        <p className="mx-6 mt-4  font-medium flex flex-row gap-2 items-center bg-amber-400 text-white w-max py-1 px-3 rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
          Instructions{" "}
        </p>

        <li className="m-6">You are expected to write at max 200 words for each scenario.</li>
<li className="m-6">Focus on being reflective and analytical.</li>
<li className="m-6">Apply critical thinking to evaluate your approaches to each scenario.</li>
<li className="m-6">Structure your response coherently, ensuring clarity in your examples and explanations.</li>
<li className="m-6">Emphasize your personal leadership journey and how these scenarios shape your adaptability.</li>

      </ul>

      <div className="mt-6 flex justify-start w-full">
        <div className="form-control w-full ">
          <label className="label">
            <span className="label-text">Response</span>
          </label>
          <textarea
            value={swotSubmission.response ?? ""}
            onChange={(e) =>
              setSubmission((prev) => ({
                ...prev,
                response: e.target.value,
              }))
            }
            className="textarea textarea-sm textarea-bordered h-20"
            placeholder="Type here..."
          ></textarea>
        </div>
      </div>

      <button className="btn btn-primary mt-8 bg-neutral-50" onClick={handleStepSubmission} disabled={status === 'Completed'}>
        Submit
      </button>
    </section>,

<section className="bg-white contMain flex items-start flex-row gpWindow rounded-lg mt-6 p-8">
{/* Step 1 content */}
<Confetti numberOfPieces={100} />
<div className="mx-auto max-w-screen-xl px-4 py-8 sm:py-12 sm:px-6 lg:py-16 lg:px-8">
  <div className="grid grid-cols-1 gap-8 lg:gap-16">


    <div className="">
      <h2 className="text-xl font-medium sm:text-xl">
        <b>Congratulations on completing Week 11: Mastering Adaptability! </b>
      </h2>
      <p class="mt-4 text-gray-600">
This week has been pivotal in enhancing your leadership skills, particularly in situations that demand agility and the ability to cope with change. We’ve delved deep into what adaptability means, a critical skill for leaders in today's fast-paced and ever-changing environment. This knowledge is vital for effectively navigating the uncertainties you may encounter, whether in your academic life, personal development, or while leading student-run societies. You’ve explored the importance of self-assessment and awareness in adaptability. Recognizing your own adaptability levels and areas for improvement is crucial in developing an agile and responsive approach in various scenarios, including leadership roles within student societies. You've learned about the significance of maintaining a positive attitude towards change. Embracing change as an opportunity for growth and learning is essential in both personal development and effective management of student-led initiatives. Improving your ability to quickly learn and adapt to new situations prepares you for diverse and unpredictable environments.  <br/><br/> This agility is a robust foundation for your academic, personal, and extracurricular activities. The "Adaptation in Action" activity provided a hands-on application of your adaptability skills, demonstrating how these abilities are crucial in real-world situations, including those you may face in student-led projects. Reflecting on how to apply these adaptability skills in real-life scenarios, particularly within student societies, has prepared you to face challenges with innovation and flexibility. Well done on successfully navigating through this comprehensive exploration of adaptability! As we progress to Week 12 with a focus on Resilience, continue to leverage your adaptability skills. Engage actively with the upcoming material and apply your insights to further grow as a leader who is adaptable, versatile, and resilient, both in academic settings and in your contributions to student societies. Looking forward to witnessing your continued growth in the next phase of your leadership development!</p>



      <div className="mt-6 grid grid-cols-1 gap-6">
<div className="space-y-4">


<Collapse accordionData={accordionData7} />


</div>




</div>




                <ul  className="block p-4" style={{listStyle:'circle'}}>

  </ul>
 
    </div>
  </div>
</div>
</section>
    // <section
    //   className="bg-white contMain  gpWindow rounded-lg mt-6 p-8 my-24"
    //   style={{ height: "100%" }}
    // >
    //   {/* Step 1 content */}
    //   <h2 className="text-xl font-medium sm:text-xl">
    //     <b>Case Study: Howard Schultz and Starbucks</b>
    //   </h2>
    //   <p className="mt-4 text-gray-600">

    //   </p>

    //   <ul
    //     className="mt-4 bg-gray-100 p-2 rounded-xl border-2 border-gray-200 text-sm"
    //     style={{ listStyle: "circle" }}
    //   >
    //     <p className="mx-6 mt-4  font-medium flex flex-row gap-2 items-center bg-primary text-white w-max py-1 px-3 rounded-full">
    //       <svg
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="none"
    //         viewBox="0 0 24 24"
    //         stroke-width="1.5"
    //         stroke="currentColor"
    //         className="w-6 h-6"
    //       >
    //         <path
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
    //         />
    //         <path
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    //         />
    //       </svg>
    //       Review Peer's SWOT Analysis
    //     </p>

    //     <p className="mx-6 mt-8 mb-2 font-bold">Strength: </p>
    //     <li className="mx-6">{assignedReview.strengths}</li>

    //     <p className="mx-6 mt-8 mb-2 font-bold">Weaknesses: </p>
    //     <li className="mx-6">{assignedReview.weaknesses}</li>

    //     <p className="mx-6 mt-8 mb-2 font-bold">Opportunities: </p>
    //     <li className="mx-6">{assignedReview.opportunities}</li>

    //     <p className="mx-6 mt-8 mb-2 font-bold">Threats: </p>
    //     <li className="mx-6 mb-4">{assignedReview.threats}</li>
    //   </ul>

    //   <div className="mt-6 flex justify-start w-full">
    //     <div className="form-control w-full ">
    //       <label className="label">
    //         <span className="label-text">Feedback</span>
    //       </label>
    //       <textarea
    //         value={swotFeedback}
    //         className="textarea textarea-sm textarea-bordered h-20"
    //         placeholder="Type here..."
    //         onChange={(e) => setFeedback(e.target.value)}
    //       ></textarea>
    //     </div>
    //   </div>

    //   <button className="btn btn-primary mt-8 bg-neutral-50" onClick={handleStepSubmission}

    //   disabled={
    //     assignedReview === ''}
      
    //   >
    //     Submit
    //   </button>


    // </section>,
  ];

  const getTitle = (currentStep) => {
    switch (currentStep) {
      case 0:
        return "Introduction";

      case 1:
        return "Objectives";

      case 2:
        return "View Slides";

      case 3:
        return "Embarking on the Journey of Self-Awareness";

      case 4:
        return "SWOT Analysis";

      case 5:
        return "Peer Review | SWOT Analysis";

      default:
        return "Page";
    }
  };

  return (
    <div>


<div>
      <div>
        <>
          <div class="absolute w-full bg-lilac h-96 min-h-96 md:min-h-96"></div>

          <main className="relative h-full max-h-screen transition-all duration-200 ease-in-out rounded-xl">
          <NavbarBack/>
            <div className="w-full px-6 py-6 mx-auto">

         
            <div className="w-full bg-white rounded-full">

            {steps[currentStep]}

            </div>


              <div className="btm-nav btm-nav-lg bg-primary shadow-lg rounded-xl w-11-12 mx-auto fixed bottom-4 mt-4">
                <span className="text-sm hidden md:flex">{getTitle(currentStep)}</span>

                <div className="flex justify-cente px-6 flex-row items-center gap-4">
                  <p className="text-sm font-medium m-0">
                    {Math.floor(((currentStep) / totalSteps) * 100)}%
                  </p>
                  <progress
                    className="progress bg-indigo-500 progress-success w-56"
                    value={Math.floor(((currentStep) / totalSteps) * 100)}
                    max="100"
                  ></progress>
                  <p className="text-sm font-medium m-0">🏆</p>
                </div>

                <div>
                {(() => {
        if (currentStep<totalSteps) {
          return (
            <div className="join">
                    <button
                      className="btn bg-locked join-item"
                      onClick={handleBack}
                      disabled={
                        (currentStep < 1)
                        }
                    >
                      ‹ Back
                    </button>
                    <button
                      className="btn bg-locked join-item"
                      onClick={handleNext}
                      // disabled={
                      //   currentStep === 2 && (currentImageIndex<6) ||
                      //   currentStep === 4 && (swotSubmission.threats === '' && swotSubmission.strengths === '' && swotSubmission.weaknesses === '' && swotSubmission.opportunities === '')
                      //   }
                    >
                      Next ›
                    </button>
                  </div>
          )
        }
        else {
          return (
            <div className="join">
                    <button
                      className="btn bg-locked join-item"
                      onClick={handleBack}
                    >
                      ‹ Back
                    </button>
                    <button
                      className="btn bg-locked join-item"
                      onClick={() => navigate(-1)}
                    >
                      Finish Week ›
                    </button>
                  </div>
          )
        }
      })()}
                  
                </div>
              </div>
            </div>
          </main>
        </>
      </div>
    </div>

    {/* <div className="bgGray">
      <div className="">
        <div className="flex flex-col flex-1 bgGray h-full">
          <main className="flex-1">

         
            <div className="">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 h-full mb-28">
                <div></div>

                {steps[currentStep]}

     
                <div className="fixed inset-x-0 bottom-0 mt-12">
                  <div className="relative bg-primary flex justify-between mx-auto w-full items-center text-white statusTray">
                    <p className="text-sm font-medium">
                      {getTitle(currentStep)}
                    </p>

                    <div className="flex justify-row items-center gap-4">
                      <p className="text-sm font-medium">
                        {Math.floor(((currentStep + 1) / totalSteps) * 100)}%
                      </p>
                      <progress
                        className="progress bg-indigo-500 progress-success w-56"
                        value={Math.floor(
                          ((currentStep + 1) / totalSteps) * 100
                        )}
                        max="100"
                      ></progress>
                      <p className="text-sm font-medium">🏆</p>
                    </div>

                    <div className="flex flex-row gap-2 items-center">
                      <button
                        className="btn btn-sm bg-white text-primary hover:text-white"
                        onClick={handleBack}
                        style={{
                          display: currentStep === 0 ? "none" : "block",
                        }}
                      >
                        Back
                      </button>
                   

                      <button
                        className={`btn btn-sm bg-white text-primary hover:text-white`}
                        onClick={handleNext}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div> */}

    </div>
  );
};

export default Week11;
